import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ReactSession } from "../../../lib/secure_reactsession";
import { LayoutResearcher } from "../../themes/userq/Layouts/layout_researcher";
import { useState, useEffect, useRef } from "react";
import {
    getResearcherTestResultData,
    getTestPreferenceTestData,
    getLoadMoreSurveyQuestionData,
    getPreferenceTestQuestionResultData,
    generateAISummary,
    submitAiSummarizeFeedback,
} from "../../../services/researcher_test_results";
import toast from "react-hot-toast";
import moment from "moment";
import { calculateTime, showToast } from "../../../lib/helpers";
import { useRecoilState } from "recoil";
import { testResultAtomFamily, testProjectAtomFamily } from "../../../store/testResultAtoms";
import TaskAttempts from "./components/preference_test/task_attempts";
import { LoadingIcon } from "../../loader/loadingIcon";
import { TestResultsHeader } from "../../themes/userq/TestResultsHeader/TestResultsHeader";
import { TestResultsSidebarNavigation } from "./components/test_results_sidebar_navigation";
import { Text } from "../../themes/userq/Text/Text";
import { Icon } from "../../themes/userq/Icon/Icon";
import { QuestionsDropdown } from "../../themes/userq/QuestionsDropdown/QuestionsDropdown";
import { LikertScaleAggregateData } from "../../themes/userq/LikertScaleAggregateData/LikertScaleAggregateData";
import { LikertScaleChart } from "../../themes/userq/LikertScaleChart/LikertScaleChart";
import { LikertScaleByUser } from "../../themes/userq/LikertScaleByUser/LikertScaleByUser";
import { Button } from "../../themes/userq/Button/Button";
import { Search } from "../../themes/userq/Search/Search";

import { ByUserTable } from "../../themes/userq/ByUserTable/ByUserTable";
import { PieStatsBoxSingleChoice } from "./components/pie_stats_box_singlechoice";
import { HorizontalBarChartStatsBoxMultipleChoice } from "./components/horizontal_bar_chart_stats_box_multiplechoice";
import { HorizontalBarChartStatsBoxRankingScale } from "./components/horizontal_bar_chart_stats_box_rankingscale";
import { AggregatedDataTable } from "../../themes/userq/AggregatedDataTable/AggregatedDataTable";
import HideParticipant from "./dialog/hide-participant";
import ReportAnswer from "./dialog/report-answer";
import { Helmet } from "react-helmet";
import { RatingScaleChart } from "../../themes/userq/RatingScale/RatingScaleChart";
import { RatingMultiSelect } from "../../themes/userq/MultiSelecteDropdownList/RatingMultiSelect";
import { Preview } from "../../themes/userq/Preview/preview";
import InnerNavigationTab from "../../themes/userq/InnernavigationTab/innerNavigationTab";
import { AIFeatureBanner } from "./components/ai_feature_banner";

export function compare(a, b) {
    const value1 = a[1]["averageranking"];
    const value2 = b[1]["averageranking"];

    let comparison = 0;

    if (value1 > value2) {
        comparison = -1;
    } else if (value1 < value2) {
        comparison = 1;
    }
    return comparison;
}

export default function TestResultPreferenceTest({ isSharedLink }) {
    let { test_id } = useParams();

    const location = useLocation();

    const scrollContainerRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);

    const navigate = useNavigate();

    const [, setLoading] = useState(false);

    const [pref, setPref] = useState(null);

    const [order, setOrder] = useState("Preference");

    const [pref_direction, setPrefDirection] = useState("desc");

    const [votes_direction, setVotesDirection] = useState("asc");

    const [time_direction, setTimeDirection] = useState("asc");

    const [designs, setDesigns] = useState([]);

    const [sectionLoading, setSectionLoading] = useState(false);

    const [openDesignModal, setOpenDesignModal] = useState({
        active: false,
        img: null,
    });

    const [test, setTest] = useRecoilState(testResultAtomFamily(test_id));
    const [task, setTask] = useState({});

    const [questionArray, setQuestionArray] = useState([]);
    const [resultCount, setResultCount] = useState(0);
    const [isActive, setActive] = useState(0);

    const [metaData, setMetaData] = useState({
        questionType: "",
        anyOptionHaveImage: false,
        totalResultCount: 0,
        userType: "",
        aggregate_total_voters: 0,
        sort_time: "",
        sort_date: "",
        sort_vote: "",
        load_more: "",
        test_question_id: "",
        page: 1,
    });
    const [search, setSearch] = useState("");
    const [searchLoading, setSearchLoading] = useState("");
    const [chartData, setChartData] = useState({});
    const [rankingchartData, setRankingChartData] = useState({});
    const [matrixArray, setMatrixArray] = useState([]);
    const [sortedchartData, setSortedChartData] = useState([]);
    const [rankingTableData, setRankingTableData] = useState([]);
    const [searchByUser, setSearchByUser] = useState("");
    const [rating, setRating] = useState([]);
    const [searchAggregateData, setSearchAggregateData] = useState("");
    const [likertQuestion, setLikertQuestion] = useState({});

    const [predictions, setPredictions] = useState({
        average: null,
        csat: null,
        nps: null,
    });

    const [, setSortLoading] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [activeMenu, setActiveMenu] = useState("Aggregated");
    const [answerArray, setAnswerArray] = useState([]);
    const [aggregrateArray, setAggregrateArray] = useState([]);

    const [loadMoreLoading, setLoadMoreLoading] = useState(false);
    const [openDeleteAnswerModal, setOpenDeleteAnswerModal] = useState({
        active: false,
        test_result_id: null,
        hidden_result: false,
    });

    const [openReportAnswerModal, setOpenReportAnswerModal] = useState({
        active: false,
        answer_id: null,
    });
    const [show_support_panel, setShowSupportPanel] = useState(false);

    const [aiSummaryLoading, setAiSummaryLoading] = useState(false);
    const [aiSummary, setAiSummary] = useState(null);
    const [aiAssistantEnabled, setAiAssistantEnabled] = useState(false);
    const [helpfulVote, setHelpfulVote] = useState(null);

    const resetAiSummaryState = () => {
        setAiSummary(null);
        setHelpfulVote(null);
        setAiSummaryLoading(false);
        setAiAssistantEnabled(false);
        setAnswerArray((prev) =>
            prev.map((item) => ({
                ...item,
                ai_summary: null,
            }))
        );
    };

    const handleAiAssistantToggle = (isEnabled) => {
        setAiAssistantEnabled(isEnabled);
        if (!isEnabled) {
            resetAiSummaryState();
        }
    };

    const [project, setProject] = useRecoilState(testProjectAtomFamily(test_id));

    let searchController = useRef();

    const sortDesigns = (order, dir, designs = []) => {
        var api_designs = [];

        if (designs.length > 0) {
            api_designs = Object.assign([], designs);
        } else {
            api_designs = Object.assign([], task.designs);
        }

        if (order == "preference") {
            order = "votes";
        }
        if (order == "time") {
            order = "time_spent";
        }

        for (var i = 0; i < api_designs.length - 1; i++) {
            for (var j = i + 1; j < api_designs.length; j++) {
                if (dir == "desc") {
                    if (
                        parseInt(api_designs[i][order]) < parseInt(api_designs[j][order])
                    ) {
                        const temp = api_designs[i];

                        api_designs[i] = api_designs[j];

                        api_designs[j] = temp;
                    }
                } else {
                    if (
                        parseInt(api_designs[i][order]) > parseInt(api_designs[j][order])
                    ) {
                        const temp = api_designs[i];

                        api_designs[i] = api_designs[j];

                        api_designs[j] = temp;
                    }
                }
            }
        }
        setDesigns(api_designs);
        return api_designs;
    };

    const getTestPreferenceTestDataApi = () => {
        let token = ReactSession.get("token");

        setSectionLoading(true);

        let guest_result_token = "";

        if (location.pathname.substr(1, 1) === "v") {
            if (!ReactSession.get("guest_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("guest_result_token", randomToken);
            }

            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";

        if (location.pathname.substr(1, 1) === "a") {
            if (!ReactSession.get("admin_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("admin_result_token", randomToken);
            }

            admin_result_token = ReactSession.get("admin_result_token");
        }

        getTestPreferenceTestData(
            {
                test_id: test_id,
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
            },
            token
        ).then((response) => {
            if (response.success) {
                setTask(response.data);

                var pref = [];

                var votes = null;

                setDesigns(response.data.designs);

                setOrder("preference");

                setPrefDirection("desc");

                var designsLoc = sortDesigns(
                    "preference",
                    "desc",
                    response.data.designs
                );

                if (designsLoc.length > 0) {
                    for (var key in designsLoc) {
                        if (
                            (designsLoc[key].votes != votes && parseInt(key) != 0) ||
                            designsLoc[key].votes == 0
                        ) {
                            break;
                        }
                        votes = designsLoc[key].votes;

                        pref.push(
                            designsLoc[key].title
                                ? designsLoc[key].title
                                : "design " + (parseInt(key) + 1)
                        );
                    }
                    if (pref.length > 0) {
                        if (pref.length > 1) {
                            let last = pref.pop();
                            let result = pref.join(", ") + " and " + last;
                            setPref(result);
                        } else {
                            setPref(pref.join(", "));
                        }
                    }
                }
                getQuestions();
            } else {
                if (response.message == "Project not found.") {
                    navigate("/404");
                } else {
                    showToast(response.message, "error");
                }
            }
        });
    };

    const getTestafterEndTest = () => {
        let token = ReactSession.get("token");

        let guest_result_token = "";

        if (location.pathname.substr(1, 1) === "v") {
            if (!ReactSession.get("guest_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("guest_result_token", randomToken);
            }

            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";

        if (location.pathname.substr(1, 1) === "a") {
            if (!ReactSession.get("admin_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("admin_result_token", randomToken);
            }

            admin_result_token = ReactSession.get("admin_result_token");
        }

        getResearcherTestResultData(
            {
                test_id: test_id,
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
            },
            token
        ).then((response) => {
            setLoading(false);

            if (response.success) {
                setTest(response.test);
            } else {
                showToast(response.message, "error");
            }
        });
    };

    const getTest = () => {
        if (!test) {
            let token = ReactSession.get("token");

            setLoading(true);

            let guest_result_token = "";

            if (location.pathname.substr(1, 1) === "v") {
                if (!ReactSession.get("guest_result_token")) {
                    const randomToken = Math.random().toString(36).substr(2, 15);
                    ReactSession.set("guest_result_token", randomToken);
                }

                guest_result_token = ReactSession.get("guest_result_token");
            }
            let admin_result_token = "";

            if (location.pathname.substr(1, 1) === "a") {
                if (!ReactSession.get("admin_result_token")) {
                    const randomToken = Math.random().toString(36).substr(2, 15);
                    ReactSession.set("admin_result_token", randomToken);
                }

                admin_result_token = ReactSession.get("admin_result_token");
            }

            getResearcherTestResultData(
                {
                    test_id: test_id,
                    guest_result_token: guest_result_token,
                    admin_result_token: admin_result_token,
                },
                token
            ).then((response) => {
                setLoading(false);

                if (response.success) {
                    if (response.workspace_project_team_member) {
                        if (response.workspace_project_team_member.status != "active") {
                            navigate(
                                "/wsp/" +
                                response.workspace_project_team_member.workspace_id +
                                "/p/" +
                                response.workspace_project_team_member.workspace_project_id +
                                "/project-no-access"
                            );
                        }
                    }
                    if (response.test && response.test.workspace_project) {
                        setProject(response.test.workspace_project);
                    }
                    if (
                        location.pathname.substr(1, 1) === "v" &&
                        response.is_share_result
                    ) {
                        navigate(`/v/results/${test_id}/results-not-available`);
                    }

                    if (
                        location.pathname.substr(1, 1) === "v" &&
                        response.test.password &&
                        !response.test_password_verify
                    ) {
                        navigate(`/v/results/${test_id}/password`);
                    }
                    setTest(response.test);

                    getTestPreferenceTestDataApi();
                } else {
                    if (response.message == "Project not found.") {
                        navigate("/404");
                    } else if (response.message == "Test Record Not found") {
                        navigate("/404");
                    } else {
                        if (location.pathname.substr(1, 1) === "v") {
                            if (
                                response.test_shared_results &&
                                !response.test_password_verify
                            ) {
                                return navigate(`/v/results/${test_id}/password`);
                            } else if (!response.test_shared_results) {
                                return navigate(`/v/results/${test_id}/results-not-available`);
                            }
                        }
                        if (location.pathname.substr(1, 1) === "a") {
                            if (!response.test_results_available) {
                                return navigate(`/v/results/${test_id}/results-not-available`);
                            }
                        }
                        showToast(response.message, "error");
                    }
                }
            });
        } else {
            getTestPreferenceTestDataApi();
        }
    };

    const handleScroll = () => {
        const scrolled = scrollContainerRef.current.scrollTop > 0;
        setIsScrolled(scrolled);
    };

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;

        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);

            return () => {
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, [rankingTableData]);

    useEffect(() => {
        getTest();
    }, []);

    const callbackTopbar = (data) => {
        getTest();
        getTestafterEndTest();
    };

    const getQuestions = () => {
        let token = ReactSession.get("token");

        setSectionLoading(true);

        let guest_result_token = "";

        if (location.pathname.substr(1, 1) === "v") {
            if (!ReactSession.get("guest_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("guest_result_token", randomToken);
            }

            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";

        if (location.pathname.substr(1, 1) === "a") {
            if (!ReactSession.get("admin_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("admin_result_token", randomToken);
            }

            admin_result_token = ReactSession.get("admin_result_token");
        }

        getPreferenceTestQuestionResultData(
            {
                test_id: test_id,
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
            },
            token
        ).then((response) => {
            setSectionLoading(false);

            if (response.success) {
                setQuestionArray(response.data);
                changeActiveQuestion(1, response.data);
                setResultCount(response.resultcount);
            } else {
                toast(
                    <div className="toastinner">
                        {response.message}
                        <a
                            onClick={() => {
                                toast.dismiss();
                            }}
                        >
                            &times;
                        </a>
                    </div>,
                    {
                        className: response.success ? "successtoast" : "errortoast",
                        position: "bottom-center",
                        duration: 2000,
                    }
                );
            }
        });
    };

    const changeActiveQuestion = (index, data) => {
        setActive(index);
        resetAiSummaryState();
        setSearch("");
        setSearchByUser("");
        setRating([]);
        const dataAnswer = data.filter(
            (item, indexItem) => indexItem + 1 === index
        )[0];

        if (dataAnswer) {
            let resultArray = dataAnswer.result;
            setAnswerArray(resultArray);
            setAggregrateArray(dataAnswer.aggregate);
            if (dataAnswer.question_type == "multiplechoice") {
                setChartData(dataAnswer.chartDataMultipleChoice);
            } else {
                setChartData(dataAnswer.chartData);
            }
            if (dataAnswer.question_type == "rankingscale") {
                setRankingChartData(dataAnswer.rankingchartData);
                setRankingTableData([dataAnswer.rankingtableData]);
            }
            if (
                dataAnswer.question_type == "likertscale" ||
                dataAnswer.question_type == "likertscale_single"
            ) {
                let matrixData = [];

                dataAnswer.matrix.forEach((items) => {
                    var totalheat = 0;
                    dataAnswer.matrix.forEach((entry) => {
                        if (items.y == entry.y) {
                            totalheat = totalheat + entry.heat;
                        }
                    });
                    var fill = "";
                    if (Math.round(((items.heat * 100) / totalheat) * 100) / 100 >= 80) {
                        fill = "#5C208D";
                    } else if (
                        Math.round(((items.heat * 100) / totalheat) * 100) / 100 >= 60 &&
                        Math.round(((items.heat * 100) / totalheat) * 100) / 100 < 80
                    ) {
                        fill = "#793EAB";
                    } else if (
                        Math.round(((items.heat * 100) / totalheat) * 100) / 100 >= 40 &&
                        Math.round(((items.heat * 100) / totalheat) * 100) / 100 < 60
                    ) {
                        fill = "#9759CB";
                    } else if (
                        Math.round(((items.heat * 100) / totalheat) * 100) / 100 >= 20 &&
                        Math.round(((items.heat * 100) / totalheat) * 100) / 100 < 40
                    ) {
                        fill = "#BF8EE8";
                    } else if (
                        Math.round(((items.heat * 100) / totalheat) * 100) / 100 > 0 &&
                        Math.round(((items.heat * 100) / totalheat) * 100) / 100 < 20
                    ) {
                        fill = "#EFDCFF";
                    } else {
                        fill = "#E9E9E9";
                    }

                    matrixData.push({
                        x: items.x,
                        y: items.y,
                        heat: items.heat,
                        fill: fill,
                        participants:
                            Math.round(((items.heat * 100) / totalheat) * 100) / 100 +
                            "% Participants",
                        percent_participants:
                            Math.round(((items.heat * 100) / totalheat) * 100) / 100,
                    });
                });

                setMatrixArray(matrixData);
                setLikertQuestion(dataAnswer.questions);
            }
            if (dataAnswer.question_type == "ratingscale") {
                setMatrixArray(dataAnswer.matrix);
                setLikertQuestion(dataAnswer.questions);
                setPredictions({
                    average: dataAnswer.average,
                    nps: dataAnswer.nps,
                    csat: dataAnswer.csat,
                });
            }

            let sortable = [];
            for (var option in dataAnswer.chartData) {
                sortable.push([option, dataAnswer.chartData[option]]);
            }

            sortable.sort(function (a, b) {
                return b[1] - a[1];
            });

            setSortedChartData(sortable);

            setMetaData({
                anyOptionHaveImage: dataAnswer.any_option_have_image
                    ? dataAnswer.any_option_have_image
                    : false,
                questionType: dataAnswer.question_type,
                totalResultCount: dataAnswer.result_count,
                userType: dataAnswer.question_type === "free" ? "by-user" : "chart",
                aggregate_total_voters: dataAnswer.aggregate_total_voters,
                sort_result_id: "asc",
                sort_time: "",
                sort_date: "",
                sort_vote: "",
                load_more: dataAnswer.result_count > 10 ? true : false,
                test_question_id: dataAnswer.id,
                page: 1,
            });
        }
    };

    const handleGenerateAISummary = () => {
        if (!metaData.test_question_id || metaData.questionType !== "free") {
            return;
        }

        const question_results = answerArray
            .filter((row) => row && row.id != null)
            .map((row) => ({
                id: row.id,
                text:
                    row.answer != null
                        ? String(row.answer)
                        : row.responseText != null
                            ? String(row.responseText)
                            : "",
            }));

        if (question_results.length === 0) {
            showToast("No responses to summarize", "error");
            return;
        }

        const activeQuestionEntry = questionArray.filter(
            (item, indexItem) => indexItem + 1 === isActive
        )[0];
        const question_title =
            activeQuestionEntry?.questions?.question != null
                ? String(activeQuestionEntry.questions.question)
                : "";

        setAiSummaryLoading(true);
        let token = ReactSession.get("token");

        generateAISummary(
            {
                test_id: test_id,
                question_id: metaData.test_question_id,
                type: "PreferenceTestFollowUp",
                question_results,
                question_title,
            },
            token
        )
            .then((response) => {
                setAiSummaryLoading(false);
                if (response.success) {
                    showToast(response.message || "AI summary generated successfully", "success");

                    const aggregateSummary = response?.data?.summary ?? null;
                    setAiSummary(aggregateSummary);

                    const responsesArray = response.data?.responses || response.data;
                    const summaryMap = {};
                    if (responsesArray && Array.isArray(responsesArray)) {
                        responsesArray.forEach((summaryItem) => {
                            summaryMap[summaryItem.responseTextId] = {
                                responseText: summaryItem.responseText,
                                label: summaryItem.label,
                                responseTextId: summaryItem.responseTextId,
                            };
                        });
                    }
                    setHelpfulVote(null);

                    const updatedAnswerArray = answerArray.map((item) => {
                        if (summaryMap[item.id]) {
                            return {
                                ...item,
                                ai_summary: summaryMap[item.id],
                            };
                        }
                        return item;
                    });
                    setAnswerArray(updatedAnswerArray);
                } else {
                    showToast(response.message || "Failed to generate AI summary", "error");
                }
            })
            .catch((error) => {
                setAiSummaryLoading(false);
                showToast(
                    error?.message || "An error occurred while generating AI summary",
                    "error"
                );
            });
    };

    const handleHelpfulVoteChange = (nextVote) => {
        if (nextVote === null) {
            setHelpfulVote(null);
            return;
        }
        if (!metaData.test_question_id) {
            showToast("Question ID is missing", "error");
            return;
        }
        const token = ReactSession.get("token");
        submitAiSummarizeFeedback(
            {
                test_id: Number(test_id),
                question_id: metaData.test_question_id,
                section: "PreferenceTestFollowUp",
                ai_feedback: nextVote === "up",
            },
            token
        ).then((response) => {
            if (response != null && response.success !== false) {
                setHelpfulVote(nextVote);
            }
        });
    };

    function Position(obj) {
        var currenttop = 0;
        if (obj.offsetParent) {
            do {
                currenttop += obj.offsetTop;
            } while ((obj = obj.offsetParent));
            return [currenttop];
        }
    }

    const searchData = (search) => {
        resetAiSummaryState();
        setSearch(search);

        if (metaData.userType === "aggregated") {
            const dataAnswer = questionArray.filter(
                (item, indexItem) => indexItem + 1 === isActive
            )[0];
            if (dataAnswer) {
                const newAggregrateArray = dataAnswer.aggregate.filter(
                    (items) =>
                        items.option.toLowerCase().indexOf(search.toLowerCase()) > -1
                );
                setAggregrateArray(newAggregrateArray);
            }
        } else {
            setSearchLoading(true);
            let token = ReactSession.get("token");
            getLoadMoreSurveyQuestionData(
                {
                    test_id: test_id,
                    test_question_id: metaData.test_question_id,
                    page: 1,
                    type: metaData.questionType,
                    search: search,
                    questiontype: "Preference Test",
                },
                token
            ).then((response) => {
                setSearchLoading(false);

                if (response.success) {
                    setAnswerArray(response.data);
                    setMetaData({
                        ...metaData,
                        page: 1,
                        load_more: response.more_records,
                    });
                } else {
                    toast(
                        <div className="toastinner">
                            {response.message}
                            <a
                                onClick={() => {
                                    toast.dismiss();
                                }}
                            >
                                &times;
                            </a>
                        </div>,
                        {
                            className: response.success ? "successtoast" : "errortoast",
                            position: "bottom-center",
                            duration: 2000,
                        }
                    );
                }
            });
        }
    };

    const sortData = (type) => {
        if (type === "time") {
            if (metaData.sort_time === "asc") {
                sortDataApi("time", "desc");
            } else {
                sortDataApi("time", "asc");
            }
        } else if (type === "date") {
            if (metaData.sort_date === "asc") {
                sortDataApi("date", "desc");
            } else {
                sortDataApi("date", "asc");
            }
        } else if (type === "vote") {
            if (metaData.sort_vote === "asc") {
                setAggregrateArray(
                    aggregrateArray.sort((a, b) => (a.vote < b.vote ? 1 : -1))
                );
                setMetaData({ ...metaData, sort_vote: "desc" });
            } else {
                setAggregrateArray(
                    aggregrateArray.sort((a, b) => (a.vote > b.vote ? 1 : -1))
                );
                setMetaData({ ...metaData, sort_vote: "asc" });
            }
        } else if (type === "result_id") {
            if (metaData.sort_result_id === "asc") {
                sortDataApi("result_id", "desc");
            } else {
                sortDataApi("result_id", "asc");
            }
        }
    };

    const sortDataApi = (sortColumn, orderBy) => {
        setSortLoading(true);
        let token = ReactSession.get("token");
        let guest_result_token = "";

        if (location.pathname.substr(1, 1) === "v") {
            if (!ReactSession.get("guest_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("guest_result_token", randomToken);
            }

            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";

        if (location.pathname.substr(1, 1) === "a") {
            if (!ReactSession.get("admin_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("admin_result_token", randomToken);
            }

            admin_result_token = ReactSession.get("admin_result_token");
        }
        getLoadMoreSurveyQuestionData(
            {
                test_id: test_id,
                test_question_id: metaData.test_question_id,
                page: 1,
                type: metaData.questionType,
                search: metaData.questionType == "free" ? search : searchByUser,
                sort_column: sortColumn,
                order_by: orderBy,
                questiontype: "Preference Test",
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,
            },
            token
        ).then((response) => {
            setSortLoading(false);

            if (response.success) {
                setAnswerArray(response.data);

                if (sortColumn === "time") {
                    if (orderBy === "desc") {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "",
                            sort_time: "desc",
                            sort_date: "",
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "",
                            sort_time: "asc",
                            sort_date: "",
                            page: 1,
                            load_more: response.more_records,
                        });
                    }
                } else if (sortColumn === "result_id") {
                    if (orderBy === "desc") {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "desc",
                            sort_time: "",
                            sort_date: "",
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "asc",
                            sort_time: "",
                            sort_date: "",
                            page: 1,
                            load_more: response.more_records,
                        });
                    }
                } else {
                    if (orderBy === "desc") {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "",
                            sort_time: "",
                            sort_date: "desc",
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setMetaData({
                            ...metaData,
                            sort_result_id: "",
                            sort_time: "",
                            sort_date: "asc",
                            page: 1,
                            load_more: response.more_records,
                        });
                    }
                }
            } else {
                toast(
                    <div className="toastinner">
                        {response.message}
                        <a
                            onClick={() => {
                                toast.dismiss();
                            }}
                        >
                            &times;
                        </a>
                    </div>,
                    {
                        className: response.success ? "successtoast" : "errortoast",
                        position: "bottom-center",
                        duration: 2000,
                    }
                );
            }
        });
    };

    const loadMore = () => {
        setLoadMoreLoading(true);
        let token = ReactSession.get("token");

        let guest_result_token = "";

        if (location.pathname.substr(1, 1) === "v") {
            if (!ReactSession.get("guest_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("guest_result_token", randomToken);
            }

            guest_result_token = ReactSession.get("guest_result_token");
        }
        let admin_result_token = "";

        if (location.pathname.substr(1, 1) === "a") {
            if (!ReactSession.get("admin_result_token")) {
                const randomToken = Math.random().toString(36).substr(2, 15);
                ReactSession.set("admin_result_token", randomToken);
            }

            admin_result_token = ReactSession.get("admin_result_token");
        }

        getLoadMoreSurveyQuestionData(
            {
                test_id: test_id,
                test_question_id: metaData.test_question_id,
                page: metaData.page + 1,
                type: metaData.questionType,
                search: metaData.questionType == "free" ? search : searchByUser,
                questiontype: "Preference Test",
                guest_result_token: guest_result_token,
                admin_result_token: admin_result_token,

                previous_summary: aiSummary,
                generate_ai_summary: aiAssistantEnabled,
            },
            token
        ).then((response) => {
            setLoadMoreLoading(false);

            if (response.success) {
                const aiResponse = response?.ai_summary?.data ?? null;
                setAiSummary(aiResponse?.summary ?? null);

                const summaryMap = {};
                const aiSummaryResponses = aiResponse?.responses;
                if (aiSummaryResponses && Array.isArray(aiSummaryResponses)) {
                    aiSummaryResponses.forEach((summaryItem) => {
                        summaryMap[summaryItem.responseTextId] = {
                            responseText: summaryItem.responseText,
                            label: summaryItem.label,
                            responseTextId: summaryItem.responseTextId,
                        };
                    });
                }

                const newDataWithAI = response.data.map((item) => {
                    if (summaryMap[item.id]) {
                        return {
                            ...item,
                            ai_summary: summaryMap[item.id]
                        };
                    }
                    return item;
                });

                setAnswerArray(answerArray.concat(newDataWithAI));
                setMetaData({
                    ...metaData,
                    page: metaData.page + 1,
                    load_more: response.more_records,
                });
            } else {
                toast(
                    <div className="toastinner">
                        {response.message}
                        <a
                            onClick={() => {
                                toast.dismiss();
                            }}
                        >
                            &times;
                        </a>
                    </div>,
                    {
                        className: response.success ? "successtoast" : "errortoast",
                        position: "bottom-center",
                        duration: 2000,
                    }
                );
            }
        });
    };

    const hideParticipantModal = (id, hiddenResult) => {
        setOpenDeleteAnswerModal({
            active: true,
            test_result_id: id,
            hidden_result: hiddenResult,
        });
    };

    const reportAnswerModal = (id) => {
        setOpenReportAnswerModal({ active: true, answer_id: id });
    };

    const closeReportAnswerModal = (data) => {
        setOpenReportAnswerModal({ active: false, answer_id: null });
    };

    const searchByAggregateData = (searchAggregateData) => {
        resetAiSummaryState();
        setSearchAggregateData(searchAggregateData);
        const dataAnswer = questionArray.filter(
            (item, indexItem) => indexItem + 1 === isActive
        )[0];
        if (dataAnswer) {
            const newAggregrateArray = dataAnswer.aggregate.filter(
                (items) =>
                    items.option
                        .toLowerCase()
                        .indexOf(searchAggregateData.toLowerCase()) > -1
            );
            setAggregrateArray(newAggregrateArray);
        }
    };

    const searchByUserData = (searchByUser) => {
        resetAiSummaryState();
        setSearchByUser(searchByUser);

        setSearchLoading(true);
        if (searchController.current) {
            searchController.current.abort();
        }
        const controller = new AbortController();

        searchController.current = controller;

        let token = ReactSession.get("token");
        getLoadMoreSurveyQuestionData(
            {
                test_id: test_id,
                test_question_id: metaData.test_question_id,
                page: 1,
                type: metaData.questionType,
                search: searchByUser,
                questiontype: "Preference Test",
            },
            token,
            searchController.current?.signal
        ).then((response) => {
            if (response.success) {
                setSearchLoading(false);
                setAnswerArray(response.data);
                setMetaData({
                    ...metaData,
                    page: 1,
                    load_more: response.more_records,
                });
            } else {
                setSearchLoading(false);
                showToast(response.message, "error");
            }
        });
    };

    const searchByRating = (rating) => {
        setRating(rating);
        setSearchLoading(true);
        if (searchController.current) {
            searchController.current.abort();
        }
        const controller = new AbortController();

        searchController.current = controller;

        let token = ReactSession.get("token");
        getLoadMoreSurveyQuestionData(
            {
                test_id: test_id,
                test_question_id: metaData.test_question_id,
                page: 1,
                type: metaData.questionType,
                rating: rating,
                questiontype: "Preference Test",
            },
            token,
            searchController.current?.signal
        ).then((response) => {
            if (response.success) {
                setSearchLoading(false);
                setAnswerArray(response.data);
                setMetaData({
                    ...metaData,
                    page: 1,
                    load_more: response.more_records,
                });
            } else {
                setSearchLoading(false);
                showToast(response.message, "error");
            }
        });
    };

    const renderRankingQuestionTable = () => {
        var colors = [
            { color: "rgba(47, 46, 85)", text: "white-text" },
            { color: "rgba(89, 89, 114)", text: "white-text" },
            { color: "rgb(150, 255, 252)", text: "" },
            { color: "rgb(255, 102, 173)", text: "white-text" },
            { color: "rgb(119, 225, 254)", text: "" },
            { color: "rgba(47, 46, 85)", text: "white-text" },
            { color: "rgba(89, 89, 114)", text: "white-text" },
            { color: "rgb(150, 255, 252)", text: "" },
            { color: "rgb(255, 102, 173)", text: "white-text" },
            { color: "rgb(119, 225, 254)", text: "" },
            { color: "rgba(47, 46, 85)", text: "white-text" },
            { color: "rgba(89, 89, 114)", text: "white-text" },
            { color: "rgb(150, 255, 252)", text: "" },
            { color: "rgb(255, 102, 173)", text: "white-text" },
            { color: "rgb(119, 225, 254)", text: "" },
        ];

        var tableData = [];
        for (var i in rankingTableData[0])
            tableData.push([i, rankingTableData[0][i]]);
        tableData.sort(compare);

        return (
            <div
                ref={scrollContainerRef}
                className={`ranking-table-holder max-height-table  ${isScrolled ? "scrolled" : ""
                    } ${tableData && tableData.length > 8 ? "responsive-table-scroll" : ""
                    }`}
            >
                <table className="table prefer-aggregatd-data-table ranking-table">
                    <thead>
                        <tr>
                            <th>Answers</th>
                            {tableData.map(function (item, index) {
                                return (
                                    <th key={`rank-head-${index}`}>
                                        {index + 1 == 1
                                            ? "1st"
                                            : index + 1 == 2
                                                ? "2nd"
                                                : index + 1 == 3
                                                    ? "3rd"
                                                    : index + 1 + "th"}
                                    </th>
                                );
                            })}
                            <th className="score-heading-table">
                                <b>Score</b>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map(function (item, index) {
                            return (
                                <tr
                                    key={`rank-row-${item[0]}-${index}`}
                                    className={`${index == 0 ? "ranking-table-first-row" : ""}`}
                                >
                                    <td>
                                        <div className="d-flex table-answer-column-outer">
                                            <div
                                                style={{
                                                    backgroundColor: colors[index].color,
                                                }}
                                                className="table-color-box"
                                            ></div>
                                            <span
                                                className={`table-answer-column ${test.language == "ar" ? "arabic-font" : ""
                                                    }`}
                                            >
                                                {item[0]}
                                            </span>
                                        </div>
                                    </td>
                                    {tableData.map(function (itemm, i) {
                                        return (
                                            <td key={`rank-vote-${item[0]}-${i}`}>
                                                <div className="d-flex table-answer-column-votes">
                                                    <span className="table-votes">
                                                        {item[1]["votes"][i + 1]}
                                                    </span>
                                                    <span className="table-percentage">
                                                        {" "}
                                                        (
                                                        {Math.round(
                                                            ((item[1]["votes"][i + 1] * 100) /
                                                                metaData.totalResultCount) *
                                                            100
                                                        ) / 100}
                                                        %)
                                                    </span>
                                                </div>
                                            </td>
                                        );
                                    })}
                                    <td>{Math.round(item[1]["averageranking"] * 100) / 100}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    };

    const closeDeleteAnswerModal = (data) => {
        if (data) {
            const getAnswerArray = answerArray;
            for (var i = 0; i < getAnswerArray.length; i++) {
                if (
                    openDeleteAnswerModal.test_result_id ===
                    getAnswerArray[i].test_result_id
                ) {
                    if (getAnswerArray[i].result.is_hidden === 1) {
                        getAnswerArray[i].result.is_hidden = 0;
                    } else {
                        getAnswerArray[i].result.is_hidden = 1;
                    }
                }
            }
        }
        setOpenDeleteAnswerModal({
            active: false,
            test_result_id: null,
            hidden_result: false,
        });
    };

    const [headerHeight, setHeaderHeight] = useState(0);

    const handleHeaderHeight = (height) => {
        setHeaderHeight(height);
    };

    return (
        <LayoutResearcher
            isSharedLink={isSharedLink}
            fixed_header_target={true}
            isLoading={false}
            wrapClass={"researcher-test-view-overflow create-test-data-wrapper"}
            resultHeaderClass={"result-header"}
            skipCheck={false}
            extendedFooter={false}
            activeMenu={""}
            openSupportPanel={show_support_panel}
            hideSupportPanel={() => {
                setShowSupportPanel(false);
            }}
        >
            <Helmet>
                <title>Analyse preference test | UserQ</title>
            </Helmet>
            {test && (
                <div className="three-column-layout two-column-layout researcher-resultwrap preference-test-result-wrap analyze-results-page-wrapper">
                    <TestResultsHeader
                        project={project}
                        isSharedLink={isSharedLink}
                        test={test}
                        endedOn={
                            test.status === "completed"
                                ? moment.utc(test.ended_on).format("DD-MM-Y")
                                : ""
                        }
                        callbackTopbar={callbackTopbar}
                    />

                    <div className="three-column-layout-body">
                        <div className="three-column-layout-left">
                            <TestResultsSidebarNavigation
                                isSharedLink={isSharedLink}
                                methodology={
                                    test.methodology === "Five Seconds Test"
                                        ? "5 second test"
                                        : test.methodology
                                }
                                selected_index={4}
                                test_id={
                                    location.pathname.substr(1, 1) === "v" ? test_id : test.id
                                }
                                screening={
                                    test &&
                                        test.screening_questions &&
                                        test.screening_questions.length > 0
                                        ? "Yes"
                                        : "No"
                                }
                            />
                        </div>

                        <div className="two-column-right-side preference-test-analytics-data">
                            {sectionLoading && (
                                <div
                                    className={
                                        "page-loader accountloading-box result-sections-loader"
                                    }
                                >
                                    <LoadingIcon />
                                </div>
                            )}
                            {!sectionLoading && (
                                <>
                                    {task && task.total_answers == 0 && (
                                        <div
                                            className={`no-participants-data no-questions-data no-questions-added`}
                                        >
                                            <div
                                                className="no-page-data-wrap"
                                                style={{ marginTop: "80px" }}
                                            >
                                                <div className="no-data-icon">
                                                    <Icon
                                                        colorClass={"gray-700-svg"}
                                                        value={"attention"}
                                                        size={"large"}
                                                    />
                                                </div>

                                                <Text type={"subtitle-1"} fontWeight="medium-font">
                                                    Details are not available at the moment as the test
                                                    didn’t receive any response yet. Please come back
                                                    later.
                                                </Text>
                                            </div>
                                        </div>
                                    )}
                                    {task && task.total_answers > 0 && (
                                        <div className="bd-question-view-wrap preference-test-result">
                                            <div className="question-result-header question-result-data">
                                                <div className="question-dropdown-container">
                                                    <div className="dropdown-header">
                                                        <div>
                                                            <div>
                                                                <span className="questions-dropdown-result-count">
                                                                    {task.total_answers} answer
                                                                    {task.total_answers == 1 ? "" : "s"}
                                                                </span>
                                                            </div>
                                                            <Text
                                                                type={"subtitle-2"}
                                                                fontWeight="medium-font"
                                                                cssClasses={`${test.language == "ar" ? "arabic-font" : ""
                                                                    }`}
                                                            >
                                                                {task.title}
                                                            </Text>
                                                        </div>
                                                    </div>
                                                </div>
                                                <InnerNavigationTab
                                                    type="tab"
                                                    activeMenu={activeMenu}
                                                    cssClasses="result-navigation-outer question-navigator-active-link result-navigation pt-3"
                                                    onTabChange={(key) => {
                                                        setActiveMenu(key);
                                                    }}
                                                    items={[
                                                        {
                                                            key: `Aggregated`,
                                                            label: "Aggregated data",
                                                        },
                                                        {
                                                            key: `Byuser-Table`,
                                                            label: "By user",
                                                        },
                                                    ]}
                                                    scrollSpy={true}
                                                    scrollSpace={157}
                                                />
                                            </div>
                                            <div className="bd-que-table-wrapper">
                                                <div className="question-result-data ">
                                                    <div className="bd-que-ans-table-data-inner bd-que-aggregated-table prefer-anayl-data-table">
                                                        <div className="test-result-inner-data preference-test-results-container">
                                                            <div
                                                                className=" table-responsive mt-40"
                                                                id={"Aggregated"}
                                                            >
                                                                <div className="preference-test-question-table-header">
                                                                    <div
                                                                        className={
                                                                            "preference-test-question-table-top"
                                                                        }
                                                                    >
                                                                        <Text type="h4">Aggregated data</Text>
                                                                    </div>
                                                                    <div
                                                                        className={
                                                                            "preference-test-question-table-bottom d-flex mt-32 purpletext"
                                                                        }
                                                                    >
                                                                        {pref && (
                                                                            <>
                                                                                <Text
                                                                                    type="subtitle-1"
                                                                                    fontWeight={"medium-font"}
                                                                                >
                                                                                    It looks like your participants prefer{" "}
                                                                                    <span
                                                                                        className={` ${test.language == "ar"
                                                                                            ? "arabic-font"
                                                                                            : ""
                                                                                            }`}
                                                                                    >
                                                                                        {pref}
                                                                                    </span>
                                                                                    !
                                                                                </Text>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className={`max-height-table `}>
                                                                    <table className="prefrence-aggreatedtable prefer-aggregatd-data-table table mt-32">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Design preview</th>
                                                                                <th>Design name</th>
                                                                                <th
                                                                                    onClick={() => {
                                                                                        setOrder("preference");

                                                                                        setPrefDirection(
                                                                                            pref_direction == "asc"
                                                                                                ? "desc"
                                                                                                : "asc"
                                                                                        );

                                                                                        sortDesigns(
                                                                                            "preference",
                                                                                            pref_direction == "asc"
                                                                                                ? "desc"
                                                                                                : "asc"
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        className={`${order == "preference"
                                                                                            ? pref_direction
                                                                                            : ""
                                                                                            } col-sort justify-content-between`}
                                                                                    >
                                                                                        Preference %
                                                                                        {order == "preference" &&
                                                                                            pref_direction == "asc" && (
                                                                                                <Icon value={"sortup"} />
                                                                                            )}
                                                                                        {order == "preference" &&
                                                                                            pref_direction == "desc" && (
                                                                                                <Icon value={"sortdown"} />
                                                                                            )}
                                                                                        {order != "preference" && (
                                                                                            <Icon value={"sort-icon"} />
                                                                                        )}
                                                                                    </div>
                                                                                </th>
                                                                                <th
                                                                                    onClick={() => {
                                                                                        setOrder("votes");

                                                                                        setVotesDirection(
                                                                                            votes_direction == "asc"
                                                                                                ? "desc"
                                                                                                : "asc"
                                                                                        );

                                                                                        sortDesigns(
                                                                                            "votes",
                                                                                            votes_direction == "asc"
                                                                                                ? "desc"
                                                                                                : "asc"
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        className={`${order == "votes"
                                                                                            ? votes_direction
                                                                                            : ""
                                                                                            } col-sort justify-content-between`}
                                                                                    >
                                                                                        Votes
                                                                                        {order == "votes" &&
                                                                                            votes_direction == "asc" && (
                                                                                                <Icon value={"sortup"} />
                                                                                            )}
                                                                                        {order == "votes" &&
                                                                                            votes_direction == "desc" && (
                                                                                                <Icon value={"sortdown"} />
                                                                                            )}
                                                                                        {order != "votes" && (
                                                                                            <Icon value={"sort-icon"} />
                                                                                        )}
                                                                                    </div>
                                                                                </th>
                                                                                <th
                                                                                    onClick={() => {
                                                                                        setOrder("time_spent");

                                                                                        setTimeDirection(
                                                                                            time_direction == "asc"
                                                                                                ? "desc"
                                                                                                : "asc"
                                                                                        );

                                                                                        sortDesigns(
                                                                                            "time_spent",
                                                                                            time_direction == "asc"
                                                                                                ? "desc"
                                                                                                : "asc"
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        className={`${order == "time_spent"
                                                                                            ? time_direction
                                                                                            : ""
                                                                                            } col-sort justify-content-between`}
                                                                                    >
                                                                                        Time spent
                                                                                        {order == "time_spent" &&
                                                                                            time_direction == "asc" && (
                                                                                                <Icon value={"sortup"} />
                                                                                            )}
                                                                                        {order == "time_spent" &&
                                                                                            time_direction == "desc" && (
                                                                                                <Icon value={"sortdown"} />
                                                                                            )}
                                                                                        {order != "time_spent" && (
                                                                                            <Icon value={"sort-icon"} />
                                                                                        )}
                                                                                    </div>
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {designs.map(function (item, index) {
                                                                                return (
                                                                                    <tr
                                                                                        key={`design-row-${item.id || item.title || index}`}
                                                                                    >
                                                                                        <td>
                                                                                            <div className="preference-test-thum-preview">
                                                                                                <div className="prefer-design-image-view-hold">
                                                                                                    <div className="prefer-test-selected-design-view">
                                                                                                        {item.type == "video" && (
                                                                                                            <div className="video-design-icon">
                                                                                                                <img
                                                                                                                    src={
                                                                                                                        process.env
                                                                                                                            .REACT_APP_URL +
                                                                                                                        "images/video-play-btn.svg"
                                                                                                                    }
                                                                                                                    alt="icon"
                                                                                                                />
                                                                                                            </div>
                                                                                                        )}
                                                                                                        <img
                                                                                                            src={
                                                                                                                process.env
                                                                                                                    .REACT_APP_IMG_URL +
                                                                                                                item.thumb
                                                                                                            }
                                                                                                            style={{
                                                                                                                width: "300px",
                                                                                                                height: "140px",
                                                                                                            }}
                                                                                                        />
                                                                                                        <div
                                                                                                            className="design-max-screen-icon"
                                                                                                            onClick={() => {
                                                                                                                setOpenDesignModal({
                                                                                                                    active: true,
                                                                                                                    color: item.color,
                                                                                                                    img:
                                                                                                                        process.env
                                                                                                                            .REACT_APP_IMG_URL +
                                                                                                                        item.design_file,
                                                                                                                    type: item.type,
                                                                                                                    title: item.title,
                                                                                                                });
                                                                                                            }}
                                                                                                        >
                                                                                                            <Icon
                                                                                                                colorClass="gray-900-svg"
                                                                                                                size={"small"}
                                                                                                                value={"maximize"}
                                                                                                                hover="true"
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td
                                                                                            className={` ${test.language == "ar"
                                                                                                ? "arabic-font"
                                                                                                : ""
                                                                                                }`}
                                                                                        >
                                                                                            {item.title}
                                                                                        </td>
                                                                                        <td>
                                                                                            {task.total_answers > 0
                                                                                                ? Math.round(
                                                                                                    (item.votes /
                                                                                                        task.total_answers) *
                                                                                                    100 *
                                                                                                    100
                                                                                                ) / 100
                                                                                                : "0"}
                                                                                            %
                                                                                        </td>
                                                                                        <td>{item.votes}</td>
                                                                                        <td>
                                                                                            {calculateTime(item.time_spent)}
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>

                                                            {test && (
                                                                <>
                                                                    <div id={"Byuser-Table"}>
                                                                        <div className="preference-test-question-table-header preference-test-question-table-bottom-header  mt-40">
                                                                            <div
                                                                                className={
                                                                                    "preference-test-question-table-top "
                                                                                }
                                                                            >
                                                                                <Text type="h4">By user</Text>
                                                                            </div>
                                                                            <div
                                                                                className={
                                                                                    "preference-test-question-table-bottom d-flex purpletext mt-32"
                                                                                }
                                                                            >
                                                                                {pref && (
                                                                                    <>
                                                                                        <Text
                                                                                            type="subtitle-1"
                                                                                            fontWeight={"medium-font"}
                                                                                        >
                                                                                            It looks like your participants
                                                                                            prefer{" "}
                                                                                            <span
                                                                                                className={` ${test.language == "ar"
                                                                                                    ? "arabic-font"
                                                                                                    : ""
                                                                                                    }`}
                                                                                            >
                                                                                                {pref}
                                                                                            </span>
                                                                                            !
                                                                                        </Text>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="table-responsive preference-test-table-bottom">
                                                                            <TaskAttempts
                                                                                isSharedLink={isSharedLink}
                                                                                test_id={test_id}
                                                                                test={test}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                            {!sectionLoading &&
                                questionArray &&
                                questionArray.length > 0 &&
                                resultCount > 0 && (
                                    <div className="five-second-test-result-wrap">
                                        <div className="result-follow-up-heading">
                                            <Text type={"h4"}>Follow up questions</Text>
                                        </div>
                                        <div className="bd-question-view-wrap">
                                            <div className="question-result-header">
                                                <QuestionsDropdown
                                                    questionArray={questionArray}
                                                    changeActiveQuestionProp={(index) => {
                                                        changeActiveQuestion(index, questionArray);
                                                        setActiveMenu("chart");

                                                        var fixedElementHeight =
                                                            document.querySelector(".researcher-header")
                                                                .offsetHeight +
                                                            document.querySelector(
                                                                ".test-results-header-researcher"
                                                            ).offsetHeight;

                                                        var offsetTop = Position(
                                                            document.getElementById("followup-results")
                                                        );
                                                        window.scrollTo({
                                                            top: offsetTop - fixedElementHeight,
                                                            behavior: "smooth",
                                                        });
                                                    }}
                                                    dropdownOpen={(state) => setDropdownOpen(state)}
                                                    resultCount={metaData.totalResultCount}
                                                    test={test}
                                                    active={isActive}
                                                    onHeaderHeightChange={handleHeaderHeight}
                                                />

                                                {metaData.totalResultCount >= 1 &&
                                                    ([
                                                        "singlechoice",
                                                        "multiplechoice",
                                                        "likertscale",
                                                        "likertscale_single",
                                                        "ratingscale",
                                                    ].includes(metaData.questionType) ? (
                                                        <InnerNavigationTab
                                                            type="tab"
                                                            activeMenu={activeMenu}
                                                            cssClasses="result-navigation-outer question-navigator-active-link result-navigation pt-3"
                                                            onTabChange={(key) => {
                                                                setActiveMenu(key);
                                                            }}
                                                            items={[
                                                                {
                                                                    key: `chart`,
                                                                    label: "Chart",
                                                                },
                                                                ...(metaData.questionType !== "ratingscale" &&
                                                                    metaData.questionType !== "likertscale_single"
                                                                    ? [
                                                                        {
                                                                            key: `aggregate-data`,
                                                                            label: "Aggregated data",
                                                                        },
                                                                    ]
                                                                    : []),
                                                                {
                                                                    key: `byuser-table`,
                                                                    label: "By user",
                                                                },
                                                            ]}
                                                            scrollSpy={true}
                                                            scrollSpace={headerHeight}
                                                        />
                                                    ) : (
                                                        <div className="accountnaviagtion-outer result-navigation-outer question-navigator-active-link border-0"></div>
                                                    ))}
                                            </div>

                                            {metaData.totalResultCount < 1 ? (
                                                <div
                                                    className={`no-participants-data no-questions-data ${dropdownOpen ? "black-overlay" : ""
                                                        }`}
                                                >
                                                    <div
                                                        className="no-page-data-wrap"
                                                        style={{
                                                            marginTop: "80px",
                                                        }}
                                                    >
                                                        <div className="no-data-icon">
                                                            <Icon
                                                                colorClass={"gray-700-svg"}
                                                                value={"attention"}
                                                                size={"large"}
                                                            />
                                                        </div>

                                                        <Text type={"subtitle-1"} fontWeight="medium-font">
                                                            {resultCount > 0 ? (
                                                                <>
                                                                    Details are not available at the moment as
                                                                    this question didn’t receive any response yet.
                                                                    Users might have skipped this question.
                                                                </>
                                                            ) : (
                                                                <>
                                                                    Details are not available at the moment as the
                                                                    test didn’t receive any response yet. Please
                                                                    come back later.
                                                                </>
                                                            )}
                                                        </Text>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <div id="followup-results" className={`question-result-data  ${dropdownOpen ? "black-overlay" : ""}`}>
                                                        <div></div>
                                                        {metaData.questionType === "free" && (
                                                            <div className="free-question-result-data test-result-inner-data">
                                                                {aiAssistantEnabled &&
                                                                    aiSummary ? (
                                                                    <div className="ai-summary-box ai-summary-box-screenshot">
                                                                        <div className="ai-summary-box-header">
                                                                            <div className="ai-summary-box-header-left">
                                                                                <Text
                                                                                    type="subtitle-2"
                                                                                    fontWeight="bold-font"
                                                                                >
                                                                                    Summary
                                                                                </Text>
                                                                                <span className="ai-summary-box-header-icon">
                                                                                    <Icon
                                                                                        value="Ai"
                                                                                        size="small"
                                                                                        colorClass={
                                                                                            aiAssistantEnabled
                                                                                                ? "ai-feature-banner-icon-svg-blue"
                                                                                                : "ai-feature-banner-icon-svg-off"
                                                                                        }
                                                                                    />
                                                                                    <Text
                                                                                        type="caption"
                                                                                        fontWeight="medium-font"
                                                                                        cssClasses={
                                                                                            aiAssistantEnabled
                                                                                                ? "ai-summary-box-powered"
                                                                                                : "ai-summary-box-powered-off"
                                                                                        }
                                                                                    >
                                                                                        Powered by AI (beta)
                                                                                    </Text>
                                                                                </span>
                                                                            </div>
                                                                            <div className="ai-summary-box-header-right">
                                                                                <div className="ai-summary-box-assistant-toggle">
                                                                                    <Text
                                                                                        type="body-text-2"
                                                                                        fontWeight="medium-font"
                                                                                        cssClasses="ai-summary-box-assistant-label"
                                                                                    >
                                                                                        AI assistant
                                                                                    </Text>
                                                                                    <label className="switch ai-toggle-btn-wrap toggle-btn-wrap ai-summary-assistant-switch">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={aiAssistantEnabled}
                                                                                            onChange={(e) =>
                                                                                                handleAiAssistantToggle(
                                                                                                    e.target.checked
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                        <span className="slider round" />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {aiAssistantEnabled && (
                                                                            <>
                                                                                <div className="ai-summary-box-body">
                                                                                    {aiSummary && (
                                                                                        <Text type="body-text-3" fontWeight="normal-font" cssClasses="ai-summary-box-summary-text">
                                                                                            {aiSummary}
                                                                                        </Text>
                                                                                    )}
                                                                                </div>
                                                                                <div className="ai-summary-box-footer">
                                                                                    <Text
                                                                                        type="body-text-2"
                                                                                        fontWeight="medium-font"
                                                                                        cssClasses="ai-summary-box-helpful-text"
                                                                                    >
                                                                                        Was this helpful?
                                                                                    </Text>
                                                                                    <div className="ai-summary-box-helpful-icons">
                                                                                        <button
                                                                                            type="button"
                                                                                            className={`ai-summary-box-helpful-btn ${helpfulVote === "up"
                                                                                                ? "is-thumb-up-selected"
                                                                                                : ""
                                                                                                }`}
                                                                                            aria-label="helpful"
                                                                                            aria-pressed={
                                                                                                helpfulVote === "up"
                                                                                            }
                                                                                            onClick={() =>
                                                                                                handleHelpfulVoteChange(
                                                                                                    helpfulVote === "up"
                                                                                                        ? null
                                                                                                        : "up"
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <Icon
                                                                                                value="Like"
                                                                                                size="medium"
                                                                                                colorClass="ai-feature-banner-icon-svg"
                                                                                            />
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className={`ai-summary-box-helpful-btn ${helpfulVote === "down"
                                                                                                ? "is-thumb-down-selected"
                                                                                                : ""
                                                                                                }`}
                                                                                            aria-label="not helpful"
                                                                                            aria-pressed={
                                                                                                helpfulVote === "down"
                                                                                            }
                                                                                            onClick={() =>
                                                                                                handleHelpfulVoteChange(
                                                                                                    helpfulVote === "down"
                                                                                                        ? null
                                                                                                        : "down"
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <span className="ai-summary-thumb-down">
                                                                                                <Icon
                                                                                                    value="Like"
                                                                                                    size="medium"
                                                                                                    colorClass="ai-feature-banner-icon-svg"
                                                                                                />
                                                                                            </span>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <AIFeatureBanner
                                                                        parentClassName="ai-feature-banner-preference-test"
                                                                        onGenerateSummary={() => {
                                                                            setAiAssistantEnabled(true);
                                                                            handleGenerateAISummary();
                                                                        }}
                                                                        loading={aiSummaryLoading}
                                                                    />
                                                                )}
                                                                <div className="free-question-table-header">
                                                                    <div className="free-question-table-header-left">
                                                                        <Text
                                                                            type="subtitle-1"
                                                                            fontWeight="medium-font"
                                                                        >
                                                                            Free text
                                                                        </Text>
                                                                    </div>
                                                                    <div className="free-question-table-header-right">
                                                                        <Search
                                                                            size={"small"}
                                                                            placeholder="Search in answers"
                                                                            onChange={(e) =>
                                                                                searchData(e.target.value)
                                                                            }
                                                                            onClear={() => {
                                                                                setTimeout(() => {
                                                                                    setSearch("");
                                                                                    searchData("");
                                                                                }, 1000);
                                                                            }}
                                                                            loading={searchLoading}
                                                                            value={search}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="table-responsive">
                                                                    <ByUserTable
                                                                        aiAssistantEnabled={aiAssistantEnabled}
                                                                        methodology={"preference-test"}
                                                                        tableClass={"preference-test-user-table"}
                                                                        isSharedLink={isSharedLink}
                                                                        metaData={metaData}
                                                                        answerArray={answerArray}
                                                                        sortData={sortData}
                                                                        hideParticipantModal={hideParticipantModal}
                                                                        reportAnswerModal={reportAnswerModal}
                                                                        search={search}
                                                                        test={test}
                                                                        loadMore={loadMore}
                                                                        loadMoreLoading={loadMoreLoading}
                                                                        onAiFeedback={handleHelpfulVoteChange}
                                                                        aiFeedbackValue={helpfulVote}
                                                                        clearSearch={() => {
                                                                            setSearch("");
                                                                            searchData("");
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {metaData.questionType === "singlechoice" && (
                                                            <div id="chart-singlechoice">
                                                                <div className="free-question-result-data test-result-inner-data test-class">
                                                                    <div id="chart">
                                                                        <div className="free-question-table-header">
                                                                            <div className="free-question-table-header-left">
                                                                                <Text type="h4" fontWeight="bold-font">
                                                                                    Chart
                                                                                </Text>
                                                                            </div>
                                                                        </div>
                                                                        <div className="chart-data">
                                                                            <PieStatsBoxSingleChoice
                                                                                data={chartData}
                                                                                sortedchartData={sortedchartData}
                                                                                title={
                                                                                    <span>
                                                                                        {metaData.totalResultCount}
                                                                                        {metaData.totalResultCount == 1
                                                                                            ? " Answer"
                                                                                            : " Answers"}
                                                                                    </span>
                                                                                }
                                                                                test={test}
                                                                                totalAnswers={metaData.totalResultCount}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="aggregated-data-table"
                                                                        id="aggregate-data"
                                                                    >
                                                                        <div
                                                                            className="free-question-table-header"
                                                                            id="aggregate-data-singlechoice"
                                                                        >
                                                                            <div className="free-question-table-header-left">
                                                                                <Text type="h4" fontWeight="bold-font">
                                                                                    Aggregated data
                                                                                </Text>
                                                                            </div>
                                                                            <div className="free-question-table-header-right">
                                                                                <Search
                                                                                    size={"small"}
                                                                                    placeholder="Search in answers"
                                                                                    onChange={(e) =>
                                                                                        searchByAggregateData(
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                    onClear={() => {
                                                                                        setTimeout(() => {
                                                                                            setSearchAggregateData("");
                                                                                            searchByAggregateData("");
                                                                                        }, 0);
                                                                                    }}
                                                                                    loading={false}
                                                                                    value={searchAggregateData}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="table-responsive">
                                                                            <AggregatedDataTable
                                                                                metaData={metaData}
                                                                                aggregrateArray={aggregrateArray}
                                                                                sortData={sortData}
                                                                                search={searchAggregateData}
                                                                                test={test}
                                                                                clearSearch={() => {
                                                                                    setSearchAggregateData("");
                                                                                    searchByAggregateData("");
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="by-user-table"
                                                                        id="byuser-table"
                                                                    >
                                                                        <div
                                                                            className="free-question-table-header"
                                                                            id="byuser-singlechoice"
                                                                        >
                                                                            <div className="free-question-table-header-left">
                                                                                <Text type="h4" fontWeight="bold-font">
                                                                                    By user
                                                                                </Text>
                                                                            </div>
                                                                            <div className="free-question-table-header-right">
                                                                                <Search
                                                                                    size={"small"}
                                                                                    placeholder="Search in answers"
                                                                                    onChange={(e) =>
                                                                                        searchByUserData(e.target.value)
                                                                                    }
                                                                                    onClear={() => {
                                                                                        setTimeout(() => {
                                                                                            setSearchByUser("");
                                                                                            searchByUserData("");
                                                                                        }, 0);
                                                                                    }}
                                                                                    loading={searchLoading}
                                                                                    value={searchByUser}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div></div>
                                                                        <div className="table-responsive">
                                                                            <ByUserTable
                                                                                methodology={"preference-test"}
                                                                                tableClass={
                                                                                    "preference-test-user-table"
                                                                                }
                                                                                metaData={metaData}
                                                                                answerArray={answerArray}
                                                                                sortData={sortData}
                                                                                hideParticipantModal={
                                                                                    hideParticipantModal
                                                                                }
                                                                                reportAnswerModal={reportAnswerModal}
                                                                                search={searchByUser}
                                                                                test={test}
                                                                                loadMore={loadMore}
                                                                                loadMoreLoading={loadMoreLoading}
                                                                                clearSearch={() => {
                                                                                    setSearchByUser("");
                                                                                    searchByUserData("");
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {metaData.questionType === "multiplechoice" && (
                                                            <div id="chart-multiplechoice">
                                                                <div className="free-question-result-data test-result-inner-data">
                                                                    <div id="chart">
                                                                        <div className="free-question-table-header">
                                                                            <div className="free-question-table-header-left"></div>
                                                                        </div>
                                                                        <div className="chart-data">
                                                                            <div className="parti-ga-grapg-area">
                                                                                <HorizontalBarChartStatsBoxMultipleChoice
                                                                                    resultCount={
                                                                                        metaData.totalResultCount
                                                                                    }
                                                                                    test={test}
                                                                                    title={"Chart"}
                                                                                    data={chartData}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="aggregated-data-table"
                                                                        id="aggregate-data"
                                                                    >
                                                                        <div
                                                                            className="free-question-table-header"
                                                                            id="aggregate-data-multiplechoice"
                                                                        >
                                                                            <div className="free-question-table-header-left">
                                                                                <Text type="h4" fontWeight="bold-font">
                                                                                    Aggregated data
                                                                                </Text>
                                                                            </div>
                                                                            <div className="free-question-table-header-right">
                                                                                <Search
                                                                                    size={"small"}
                                                                                    placeholder="Search in answers"
                                                                                    onChange={(e) =>
                                                                                        searchByAggregateData(
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                    onClear={() => {
                                                                                        setTimeout(() => {
                                                                                            setSearchAggregateData("");
                                                                                            searchByAggregateData("");
                                                                                        }, 0);
                                                                                    }}
                                                                                    loading={false}
                                                                                    value={searchAggregateData}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="table-responsive">
                                                                            <AggregatedDataTable
                                                                                metaData={metaData}
                                                                                aggregrateArray={aggregrateArray}
                                                                                sortData={sortData}
                                                                                search={searchAggregateData}
                                                                                test={test}
                                                                                clearSearch={() => {
                                                                                    setSearchAggregateData("");
                                                                                    searchByAggregateData("");
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        id="byuser-multiplechoice"
                                                                        style={{
                                                                            display: "flex",
                                                                            width: "100%",
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="by-user-table"
                                                                            id="byuser-table"
                                                                            style={{
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <div className="free-question-table-header">
                                                                                <div className="free-question-table-header-left">
                                                                                    <Text
                                                                                        type="h4"
                                                                                        fontWeight="bold-font"
                                                                                    >
                                                                                        By user
                                                                                    </Text>
                                                                                </div>
                                                                                <div className="free-question-table-header-right">
                                                                                    <Search
                                                                                        size={"small"}
                                                                                        placeholder="Search in answers"
                                                                                        onChange={(e) =>
                                                                                            searchByUserData(e.target.value)
                                                                                        }
                                                                                        onClear={() => {
                                                                                            setTimeout(() => {
                                                                                                setSearchByUser("");
                                                                                                searchByUserData("");
                                                                                            }, 0);
                                                                                        }}
                                                                                        loading={searchLoading}
                                                                                        value={searchByUser}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div></div>
                                                                            <div className="table-responsive">
                                                                                <ByUserTable
                                                                                    methodology={"preference-test"}
                                                                                    tableClass={
                                                                                        "preference-test-user-table"
                                                                                    }
                                                                                    metaData={metaData}
                                                                                    answerArray={answerArray}
                                                                                    sortData={sortData}
                                                                                    hideParticipantModal={
                                                                                        hideParticipantModal
                                                                                    }
                                                                                    reportAnswerModal={reportAnswerModal}
                                                                                    search={searchByUser}
                                                                                    test={test}
                                                                                    loadMore={loadMore}
                                                                                    loadMoreLoading={loadMoreLoading}
                                                                                    clearSearch={() => {
                                                                                        setSearchByUser("");
                                                                                        searchByUserData("");
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(metaData.questionType === "likertscale" || metaData.questionType === "likertscale_single") && (
                                                            <div id="chart-likertscale">
                                                                <div className="free-question-result-data test-result-inner-data">
                                                                    <div id="chart">
                                                                        <div className="free-question-table-header">
                                                                            <div className="free-question-table-header-left">
                                                                                <Text type="h4" fontWeight="bold-font">
                                                                                    Chart
                                                                                </Text>
                                                                            </div>
                                                                        </div>
                                                                        <div className="chart-data">
                                                                            <LikertScaleChart
                                                                                data={matrixArray}
                                                                                likertQuestion={likertQuestion}
                                                                                test={test}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    {metaData.questionType !==
                                                                        "likertscale_single" && (
                                                                            <div
                                                                                className="aggregated-data-table"
                                                                                id="aggregate-data"
                                                                            >
                                                                                <div
                                                                                    className="free-question-table-header"
                                                                                    id="aggregate-data-likertscale"
                                                                                >
                                                                                    <div className="free-question-table-header-left">
                                                                                        <Text
                                                                                            type="h4"
                                                                                            fontWeight="bold-font"
                                                                                        >
                                                                                            Aggregated data
                                                                                        </Text>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className={`likert-area-chart ${test.language == "ar"
                                                                                        ? "arabic-font"
                                                                                        : ""
                                                                                        }`}
                                                                                >
                                                                                    <LikertScaleAggregateData
                                                                                        data={matrixArray}
                                                                                        likertQuestion={likertQuestion}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    <div
                                                                        id={
                                                                            metaData.questionType ===
                                                                                "likertscale_single"
                                                                                ? "byuser-likertscale_single"
                                                                                : "byuser-likertscale"
                                                                        }
                                                                        style={{
                                                                            display: "flex",
                                                                            width: "100%",
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="by-user-table"
                                                                            id="byuser-table"
                                                                            style={{
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <div className="free-question-table-header">
                                                                                <div className="free-question-table-header-left">
                                                                                    <Text
                                                                                        type="h4"
                                                                                        fontWeight="bold-font"
                                                                                    >
                                                                                        By user
                                                                                    </Text>
                                                                                </div>
                                                                            </div>
                                                                            <div></div>
                                                                            <LikertScaleByUser
                                                                                methodology={"preference-test"}
                                                                                tableClass={
                                                                                    "preference-test-user-table"
                                                                                }
                                                                                likertQuestion={likertQuestion}
                                                                                metaData={metaData}
                                                                                test_id={test_id}
                                                                                test={test}
                                                                                answerArray={answerArray}
                                                                                hideParticipantModal={
                                                                                    hideParticipantModal
                                                                                }
                                                                                reportAnswerModal={reportAnswerModal}
                                                                                loadMore={loadMore}
                                                                                loadMoreLoading={loadMoreLoading}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {metaData.questionType == "rankingscale" && (
                                                            <div id="chart-rankingscale">
                                                                <div className="test-result-inner-data parti-ga-grapg-area">
                                                                    <div className="barchart-ranking-scale">
                                                                        <HorizontalBarChartStatsBoxRankingScale
                                                                            test={test}
                                                                            rankingchartData={rankingchartData}
                                                                        />
                                                                    </div>
                                                                    <div className="ranking-scale-table mt-40">
                                                                        {renderRankingQuestionTable()}
                                                                    </div>
                                                                    <div className="ranking-page-infodata-wrap">
                                                                        <h3>How to read this bar chart?</h3>
                                                                        <p>
                                                                            The bar chart is based on the score each
                                                                            ranked option has received. The scores
                                                                            represent the average ranking.
                                                                        </p>
                                                                        <h3>How the scores are calculated?</h3>
                                                                        <p>
                                                                            Think of the score as a weighted average.
                                                                            Suppose you have 5 options for testers to
                                                                            rank. The testers’ most preferred option
                                                                            (ranked as #1 most of the times) is given
                                                                            the largest weight (in this case 5). Their
                                                                            least preferred option has a weight of 1.
                                                                            The weights are then multiplied by the
                                                                            numbers of testers selected a particular
                                                                            option. Their sum is divided by the total
                                                                            number of testers.
                                                                        </p>
                                                                        <div className="response-text-wrap">
                                                                            <p>
                                                                                X<sub>1</sub> W<sub>1</sub> + X
                                                                                <sub>2</sub> W<sub>2</sub>+ X
                                                                                <sub>3</sub> W<sub>3</sub> + ... + X
                                                                                <sub>n</sub> W<sub>n</sub>
                                                                            </p>
                                                                            <span>Total responses</span>
                                                                        </div>
                                                                        <div className="ranking-wrap-info-bottom">
                                                                            Where:
                                                                            <p>X - number of testers</p>
                                                                            <p>W - weight of the ranked option</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {metaData.questionType === "ratingscale" && (
                                                            <div id="chart-ratingscale">
                                                                <div className="free-question-result-data test-result-inner-data">
                                                                    <div id="chart">
                                                                        <div
                                                                            className="free-question-table-header"
                                                                            id="chart-ratingscale"
                                                                        >
                                                                            <div className="free-question-table-header-left">
                                                                                <Text type="h4" fontWeight="bold-font">
                                                                                    Chart
                                                                                </Text>
                                                                            </div>
                                                                        </div>
                                                                        <div className="chart-data">
                                                                            {matrixArray &&
                                                                                Object.keys(likertQuestion).length !==
                                                                                0 && (
                                                                                    <>
                                                                                        <RatingScaleChart
                                                                                            test={test}
                                                                                            data={matrixArray}
                                                                                            question={{
                                                                                                type:
                                                                                                    likertQuestion.scale_type ==
                                                                                                        "Emotions"
                                                                                                        ? "emoticons"
                                                                                                        : likertQuestion.scale_type,
                                                                                                scale:
                                                                                                    likertQuestion.scale_length.match(
                                                                                                        /\d+/
                                                                                                    )[0],
                                                                                                labels: likertQuestion.labels,
                                                                                            }}
                                                                                            predictions={predictions}
                                                                                        />
                                                                                    </>
                                                                                )}
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className="by-user-table"
                                                                        id="byuser-table"
                                                                    >
                                                                        <div className="free-question-table-header">
                                                                            <div className="free-question-table-header-left">
                                                                                <Text type="h4" fontWeight="bold-font">
                                                                                    By user
                                                                                </Text>
                                                                            </div>
                                                                        </div>
                                                                        <div className="free-question-table-header">
                                                                            <div className="free-question-table-header-left">
                                                                                <Text
                                                                                    cssClasses={"gray-color"}
                                                                                    type="body-text-3"
                                                                                    fontWeight="medium-font"
                                                                                >
                                                                                    {metaData.totalResultCount} answer
                                                                                    {metaData.totalResultCount > 1
                                                                                        ? "s"
                                                                                        : ""}
                                                                                </Text>
                                                                            </div>

                                                                            <div className="free-question-table-header-right">
                                                                                {Object.keys(likertQuestion).length !==
                                                                                    0 && (
                                                                                        <RatingMultiSelect
                                                                                            onChange={(rating) => {
                                                                                                searchByRating(rating);
                                                                                            }}
                                                                                            value={rating}
                                                                                            type={(function () {
                                                                                                var scale = {
                                                                                                    Stars: "stars",
                                                                                                    Emotions: "emoticons",
                                                                                                    Numeric: "numeric",
                                                                                                };

                                                                                                return scale[
                                                                                                    likertQuestion.scale_type
                                                                                                ];
                                                                                            })()}
                                                                                            scale={
                                                                                                likertQuestion.scale_length.match(
                                                                                                    /\d+/
                                                                                                )[0]
                                                                                            }
                                                                                        />
                                                                                    )}
                                                                            </div>
                                                                        </div>
                                                                        <div id="byuser-ratingscale"></div>
                                                                        {Object.keys(likertQuestion).length !==
                                                                            0 && (
                                                                                <ByUserTable
                                                                                    methodology={"preference-test"}
                                                                                    tableClass={
                                                                                        "preference-test-user-table"
                                                                                    }
                                                                                    metaData={metaData}
                                                                                    answerArray={answerArray}
                                                                                    sortData={sortData}
                                                                                    hideParticipantModal={
                                                                                        hideParticipantModal
                                                                                    }
                                                                                    reportAnswerModal={reportAnswerModal}
                                                                                    search={search}
                                                                                    test={test}
                                                                                    loadMore={loadMore}
                                                                                    loadMoreLoading={loadMoreLoading}
                                                                                    clearSearch={() => {
                                                                                        setRating([]);
                                                                                        searchByRating([]);
                                                                                    }}
                                                                                    question={{
                                                                                        type:
                                                                                            likertQuestion.scale_type ==
                                                                                                "Emotions"
                                                                                                ? "emoticons"
                                                                                                : likertQuestion.scale_type,
                                                                                        scale:
                                                                                            likertQuestion.scale_length.match(
                                                                                                /\d+/
                                                                                            )[0],
                                                                                    }}
                                                                                />
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="bd-question-bottom-pagination-arrow prev-next-button-bottom">
                                                            <div className="bd-que-slide-arrow tablebottompagination">
                                                                <Button
                                                                    type={"secondary"}
                                                                    microLoading={false}
                                                                    label={"Previous question"}
                                                                    size={"medium"}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        if (isActive > 1) {
                                                                            changeActiveQuestion(
                                                                                isActive - 1,
                                                                                questionArray
                                                                            );
                                                                        }
                                                                        var fixedElementHeight =
                                                                            document.querySelector(
                                                                                ".researcher-header"
                                                                            ).offsetHeight +
                                                                            document.querySelector(
                                                                                ".test-results-header-researcher"
                                                                            ).offsetHeight;

                                                                        var offsetTop = Position(
                                                                            document.getElementById(
                                                                                "followup-results"
                                                                            )
                                                                        );
                                                                        window.scrollTo({
                                                                            top: offsetTop - fixedElementHeight,
                                                                            behavior: "smooth",
                                                                        });
                                                                    }}
                                                                    iconLeft={
                                                                        <Icon
                                                                            value={"back arrow"}
                                                                            size={"medium"}
                                                                        />
                                                                    }
                                                                    state={`${isActive === 1 ? "disabled" : ""}`}
                                                                />
                                                                <Button
                                                                    type={"secondary"}
                                                                    label={"Next question"}
                                                                    size={"medium"}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        if (isActive < questionArray.length) {
                                                                            changeActiveQuestion(
                                                                                isActive + 1,
                                                                                questionArray
                                                                            );
                                                                        }
                                                                        var fixedElementHeight =
                                                                            document.querySelector(
                                                                                ".researcher-header"
                                                                            ).offsetHeight +
                                                                            document.querySelector(
                                                                                ".test-results-header-researcher"
                                                                            ).offsetHeight;

                                                                        var offsetTop = Position(
                                                                            document.getElementById(
                                                                                "followup-results"
                                                                            )
                                                                        );
                                                                        window.scrollTo({
                                                                            top: offsetTop - fixedElementHeight,
                                                                            behavior: "smooth",
                                                                        });
                                                                    }}
                                                                    iconRight={
                                                                        <Icon
                                                                            value={"forward-arrow"}
                                                                            size={"medium"}
                                                                        />
                                                                    }
                                                                    state={`${isActive === questionArray.length
                                                                        ? "disabled"
                                                                        : ""
                                                                        }`}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )}

                            {!sectionLoading &&
                                questionArray &&
                                questionArray.length === 0 &&
                                resultCount > 0 && (
                                    <div
                                        className={`no-participants-data no-questions-data ${dropdownOpen ? "black-overlay" : ""
                                            }`}
                                    >
                                        <div
                                            className="no-page-data-wrap"
                                            style={{ marginTop: "80px" }}
                                        >
                                            <div className="no-data-icon">
                                                <Icon
                                                    colorClass={"gray-700-svg"}
                                                    value={"attention"}
                                                    size={"large"}
                                                />
                                            </div>

                                            <Text type={"subtitle-1"} fontWeight="medium-font">
                                                You have not added any questions to your test.
                                            </Text>
                                        </div>
                                    </div>
                                )}
                            {!sectionLoading && resultCount === 0 && false && (
                                <div
                                    className={`no-participants-data no-questions-data ${dropdownOpen ? "black-overlay" : ""
                                        }`}
                                >
                                    <div
                                        className="no-page-data-wrap"
                                        style={{ marginTop: "80px" }}
                                    >
                                        <div className="no-data-icon">
                                            <Icon
                                                colorClass={"gray-700-svg"}
                                                value={"attention"}
                                                size={"large"}
                                            />
                                        </div>

                                        <Text type={"subtitle-1"} fontWeight="medium-font">
                                            Details are not available at the moment as the test didn’t
                                            receive any response yet. Please come back later.
                                        </Text>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <HideParticipant
                        test_id={test_id}
                        openModal={openDeleteAnswerModal}
                        closeModal={closeDeleteAnswerModal}
                    />
                    <ReportAnswer
                        test_id={test_id}
                        openModal={openReportAnswerModal}
                        closeModal={closeReportAnswerModal}
                    />
                    <Preview
                        open={openDesignModal.active}
                        img={openDesignModal.img}
                        file_type={openDesignModal.type}
                        background={openDesignModal.color}
                        close={() => {
                            setOpenDesignModal({
                                ...openDesignModal,
                                active: false,
                            });
                        }}
                    />
                </div>
            )}
            {!isSharedLink && (
                <a
                    onClick={(e) => {
                        e.preventDefault();

                        setShowSupportPanel(true);
                    }}
                    href={process.env.REACT_APP_URL + "r/support"}
                    target="_blank"
                    className="support-button" rel="noreferrer"
                >
                    <Icon value={"support"} colorClass={"gray-50-svg"} size={"medium"} />
                    Support
                </a>
            )}
        </LayoutResearcher>
    );
}
